<template>
  <v-card>
    <v-container>
      <v-card-title class="headline">{{$t('formula')}}</v-card-title>
      <v-row class="pl-4 pr-4">
        <v-col cols="12">
          <v-textarea
            ref="fg"
            :label="$t('formula')" 
            rows="1"
            auto-grow
            v-model="tempFormula"
            :placeholder="$t('sample10')"
            :rules="rules3"
            @keyup="setCursorPostition"
            @click="setCursorPostition"
          ></v-textarea>
        </v-col>
        <v-col cols="3">
          {{$t('operator')}}
          <v-divider class="mb-2 mt-2"></v-divider>
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-row>
                <v-col sm="6" md="3">
                  <v-btn color="primary" small outlined icon @click="setFormula({code: '+'})">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
                <v-col sm="6" md="3">
                  <v-btn color="primary" small outlined icon @click="setFormula({code: '-'})">
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                </v-col>
                <v-col sm="6" md="3">
                  <v-btn color="primary" small outlined icon @click="setFormula({code: '*'})">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
                <v-col sm="6" md="3">
                  <v-btn color="primary" small outlined icon @click="setFormula({code: '/'})">
                    <v-icon>mdi-division</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-btn color="primary" block class="mt-2" small outlined @click="clearFormula">{{$t('clear')}}</v-btn>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="9">
          <v-row>
            <v-col cols="12">
              {{$t('reserved_words')}}
              <v-divider class="mb-2 mt-2"></v-divider>
            </v-col>
            <v-col cols="12">
              <v-progress-linear indeterminate color="primary" v-if="loading"></v-progress-linear>
              <v-container fill-height fluid v-if="!loading">
                <v-row>
                  <v-col
                    cols="6"
                    v-for="(item,i) in reserveWord"
                    v-bind:key="i"
                    class="pt-2 pb-2"
                    v-bind:class="[i%4 == 0 ? 'sae-lightgrey':'', i%4 == 1 ? 'sae-lightgrey':'']"
                  >
                    <v-container fill-height fluid>
                      <v-row align="center" justify="center">
                        <v-col cols="5" class="pt-0 pb-0 pr-0">
                          <v-btn
                            small
                            depressed
                            block
                            color="primary"
                            outlined
                            @click="setFormula(item)"
                            class="btw-70"
                          >{{item.code}}</v-btn>
                        </v-col>
                        <v-col cols="7" class="pt-0 pb-0 pl-2">
                          <small>&nbsp;{{item.name}}</small>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-card-actions class="pa-3">
        <v-btn color="primary" outlined @click="cancel">{{$t('cancel')}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">{{$t('done')}}</v-btn>
      </v-card-actions>
    </v-container>
  </v-card>
</template>
<script>
export default {
  props: { 'formula': { default: '' } },
  name: 'FormulaGenerator',
  data() {
    return {
      baseUrl: this.$store.state.baseUrl,
      reserveWord: [],
      tempFormula: '',
      loading: false,
      cursorPostition: 0,
      rules3: [
        v => !!v || this.$i18n.t('required'),
        v => /^[+/*\- ()<>%.,0-9a-zA-Z]+$/.test(v) || this.$i18n.t('required_math')
      ],
    }
  },
  methods: {
    setCursorPostition(event) {
      if (event) if (event.target) if (event.target.selectionStart) this.cursorPostition = event.target.selectionStart
    },
    setFormula(item) {
      const str = this.tempFormula
      const start = this.cursorPostition
      if (str) {
        this.tempFormula = str.slice(0, start) + ` ${item.code}` + str.slice(start)
        this.cursorPostition = this.cursorPostition + item.code.length + 1
      } else {
        this.tempFormula = `${item.code}`
        this.cursorPostition = item.code.length
      }
    },
    clearFormula() {
      this.tempFormula = ''
    },
    costumHeader(action, actionId) {
      return { headers: { action, actionId } }
    },
    async getReserveWord() {
      this.loading = true
      const result = await this.$store.dispatch('getPreserveWord')
      this.loading = false
      return result
    },
    save() {
      this.$emit('save', this.tempFormula)
    },
    cancel() {
      this.$emit('cancel', false)
    },
  },
  async created() {
    this.reserveWord = await this.getReserveWord()
    if (this.formula) {
      this.tempFormula = this.formula
      this.cursorPostition = this.formula.length
    }
  },
  watch: {
    formula(str) {
      this.tempFormula = str
    }
  }
}
</script>
